$(document).ready(function () {
    $(".js-course-selection")
        .on('change', function (el) {
            var dictValues = JSON.parse(el.target.dataset.mapping);

            var parentBox = el.target;
            var childBox = document.getElementById(parentBox.dataset.childId);

            var selectedValue = parentBox.options[parentBox.selectedIndex].value;

            // Clear first
            childBox.innerHTML = " ";

            for (var i = 0; i <= dictValues.length -1; i++)
            {
                if (selectedValue === dictValues[i].Key && dictValues[i].Value !== undefined)
                {
                    for (var j = 0; j <= dictValues[i].Value.length -1; j++)
                    {
                        if (dictValues[i] !== undefined && dictValues[i].Value[j].Value !== undefined)
                        {
                            var elOptNew = document.createElement('option');
                            elOptNew.text = dictValues[i].Value[j].Caption;
                            elOptNew.value = dictValues[i].Value[j].Caption;
                            childBox.options.add ( elOptNew );
                        }
                    }
                }
            }
        });
    });
